import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import convert from 'utils/dateTools';
import map from 'lodash/map';
import filter from 'lodash/filter';
import pallet from 'constants/colors';

import { Divider, ListItem } from 'material-ui';
import KFlatButton from 'components/KJRN/KFlatButton';

import { FormattedMessage } from 'react-intl';

import TMessage from './TMessage';
import TLoading from './TLoading';

const styles = {
  container: {
    width: 'calc(100% - 72px)',
    height: 'calc(100% - 26px)',
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 18,
    paddingBottom: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  action: {
    flex: '1 1 0',
    justifyContent: 'center',
    minHeight: 40,
    maxHeight: 40,
  },
  actionButton: {
    maxWidth: 'none',
    fontSize: 14,
  },
  appraisal: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 18,
    paddingBottom: 18,
  },
  secondary: {
    display: 'flex',
    alignItems: 'center',
    height: 40,
    justifyContent: 'space-between',
  },
  tag: {
    fontSize: 14,
    color: 'white',
    borderRadius: 4,
    padding: 6,
  },
  managerDivider: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minHeight: 18,
    marginTop: 18,
  },
};
/* eslint-disable-next-line react/prefer-stateless-function */
class TAppraislas extends React.Component {
  render() {
    const {
      appraisals,
      loading,
      error,
    } = this.props;

    if (error) {
      return <TMessage type="error" message="tile.appraisals.error" />;
    }

    if (loading) {
      return <TLoading />;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const list = filter(appraisals, a => (new Date(a.EmployeeDueDate).getTime() >= today.getTime()) && a.EmployeeStatus < 2);

    if (!list || !list.length) {
      return (
        <TMessage message="tile.appraisals.empty">
          <KFlatButton
            style={styles.actionButton}
            onClick={() => this.context.router.push('/appraisals')}
            containerStyle={styles.action}
            label={<FormattedMessage id="tile.appraisals.goto" />}
          />
        </TMessage>
      );
    }

    return (
      <div style={styles.container}>
        {map(list, appr => (
          <div key={appr.PMAppraisalID}>
            <ListItem
              className="appraisal-item"
              innerDivStyle={styles.appraisal}
              hoverColor="transparent"
              primaryText={appr.PMFormTitle}
              secondaryText={
                <div style={styles.secondary}>
                  {convert(appr.EmployeeDueDate)}
                  {appr.EmployeeStatus === 0 &&
                    <div style={{ ...styles.tag, backgroundColor: pallet.errorColor }}>
                      <FormattedMessage id="tile.appraisals.start" />
                    </div>
                  }
                  {appr.EmployeeStatus === 1 &&
                    <div style={{ ...styles.tag, backgroundColor: pallet.warningColor }}>
                      <FormattedMessage id="tile.appraisals.handin" />
                    </div>
                  }
                </div>
              }
              onClick={() => this.context.router.push(`/appraisals/${appr.PMAppraisalID}`)}
            />
            <Divider />
          </div>
        ))}

        <KFlatButton
          style={styles.actionButton}
          onClick={() => this.context.router.push('/appraisals')}
          containerStyle={styles.action}
          label={<FormattedMessage id="tile.appraisals.goto" />}
        />
      </div>
    );
  }
}

TAppraislas.contextTypes = {
  router: PropTypes.object.isRequired,
};

TAppraislas.propTypes = {
  appraisals: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

export default connect(state => ({ ...state.Appraisal }))(TAppraislas);



// WEBPACK FOOTER //
// ./src/containers/tiles/TAppraisals.js